<script setup>
import { ref, onMounted, onUnmounted, inject, watch} from 'vue'
import { useWorkspaceStore } from '@stores/WorkspaceData';
const wpStore = useWorkspaceStore()
import { timeService } from '@requests/Main/time.service';
import DatePicker from 'primevue/datepicker';
const toast = inject('toast')
import { unixToIsoMsk, isoToUnixMsk } from '@services/process/Main/unix.servise';
onMounted(async () => {
  selectData.value = wpStore.time
  TimeForDatePicker.value.horizonEnd = unixToIsoMsk(selectData.value.horizonEnd)
  TimeForDatePicker.value.horizonStart = unixToIsoMsk(selectData.value.horizonStart)
  TimeForDatePicker.value.step = selectData.value.simulationStep
  // Автосохранение подключаем после заполнения формы, чтобы открытие вкладки не вызывало PUT
  stopAutoSave = watch(TimeForDatePicker, () => debouncedSave(), {deep: true})
})
let stopAutoSave = null
onUnmounted(() => {
  stopAutoSave?.()
  debouncedSave.flush()
})
const selectData = ref({})
import Select from 'primevue/select';
const Save = async () => {
  selectData.value.horizonStart = isoToUnixMsk(TimeForDatePicker.value.horizonStart)
  selectData.value.horizonEnd = isoToUnixMsk(TimeForDatePicker.value.horizonEnd)
  selectData.value.simulationStep = TimeForDatePicker.value.step
  let data = await timeService.Put(selectData.value)
  return data
}
import Fieldset from 'primevue/fieldset';
import { debounce } from 'lodash-es'
const TimeForDatePicker = ref({
    horizonStart: null,
    horizonEnd: null,
    step: null
})
const debouncedSave = debounce(() => {
  Save()
}, 500)
const StepListParam = [{label: '1/20', value: "STEP_1_20"},
  {label: '1/10', value: "STEP_1_10"},
  {label: '1/5', value: "STEP_1_5"},
  {label: '1/4', value: "STEP_1_4"},
  {label: '1/2', value: "STEP_1_2"},
  {label: '1', value: "STEP_1"}
]
</script>

<template>

<section class="SectionPanel">
<Fieldset legend="Горизонт моделирования">
  <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <DatePicker v-model="TimeForDatePicker.horizonStart" showTime hourFormat="24" showIcon showButtonBar dateFormat="dd.mm.yy"/>
        <label>Начало моделирования</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <DatePicker v-model="TimeForDatePicker.horizonEnd" showTime hourFormat="24" showIcon showButtonBar dateFormat="dd.mm.yy"/>
        <label>Конец моделирования</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <Select v-model="TimeForDatePicker.step" :options="StepListParam" optionLabel="label" optionValue="value" style="width: 100%;"/>
        <label>Шаг моделирования</label>
      </FloatLabel>
    </div>
</Fieldset>
</section>
</template>

<style>
.p-splitterpanel .ToolbarPanel{
    border: none;
    border-bottom: 1px solid var(--p-toolbar-border-color);
    border-radius: 0px;
    padding: 5px;
    position: sticky;
    top: 0px;
    z-index: 5;
}
.fieldsetDiv{
  flex: 1;
}
.fieldsetDiv.Tenzor{
    display: flex;
    flex-direction: column;
    position: relative;
}
.fieldsetDiv.Tenzor p{
    position: absolute;
    top: -15px;
    width: 100%;
    margin: 0px;
    margin: 0px;
    color: var(--p-floatlabel-active-color);
    font-size: var(--p-floatlabel-active-font-size);
    font-weight: var(--p-floatlabel-active-font-weight);
}
.fieldsetDiv.Tenzor input{
    width: 50px;
}
.input-150 input{
    width: 150px;
}
.p-splitterpanel .SectionPanel{
    display: flex;
    flex-wrap: wrap;
}
.SectionPanel .p-fieldset{
  margin: 5px 10px !important;
  width: fit-content;
}
.SectionPanel .p-fieldset .p-fieldset-content{
    display: flex;
    gap: 20px;
    flex-direction: column;
}
.SectionPanel .FieldsetTable th{
    color: var(--p-floatlabel-active-color);
    font-size: var(--p-floatlabel-active-font-size);
    font-weight: var(--p-floatlabel-active-font-weight);
    text-align: start;
}
.smallInput input{
  width: 50px;
}
</style>